import { Outlet } from 'react-router-dom';
import { Typography } from 'antd';
import { APP_NAME } from '@/utils';
import { useSettingsStore, COLOR_THEMES } from '@store/settingsStore';

export function AuthLayout() {
  const theme = useSettingsStore((s) => s.theme);
  const colorTheme = useSettingsStore((s) => s.colorTheme);
  const activeColor = COLOR_THEMES.find(t => t.key === colorTheme)?.color || '#2563eb';

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: theme === 'dark' 
          ? `linear-gradient(135deg, #09090b 0%, ${activeColor}22 50%, #09090b 100%)`
          : `linear-gradient(135deg, ${activeColor}11 0%, ${activeColor}33 100%)`,
        padding: 16,
        transition: 'background 0.3s ease',
      }}
    >
      <div style={{ width: '100%', maxWidth: 420 }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: 48,
              height: 48,
              borderRadius: '12px',
              background: `linear-gradient(135deg, ${activeColor}, ${activeColor}cc)`,
              boxShadow: `0 8px 24px ${activeColor}40`,
              marginBottom: 16,
            }}
          >
            <span style={{ color: '#ffffff', fontSize: 24, fontWeight: 'bold', fontFamily: 'Inter, sans-serif' }}>
              {APP_NAME.charAt(0)}
            </span>
          </div>
          <Typography.Title level={2} style={{ margin: 0, fontWeight: 800, letterSpacing: '-0.5px' }}>
            {APP_NAME}
          </Typography.Title>
        </div>
        <div
          style={{
            background: theme === 'dark' ? '#15151a' : '#ffffff',
            borderRadius: 16,
            padding: '36px 32px',
            boxShadow: theme === 'dark' 
              ? '0 20px 40px rgba(0,0,0,0.5), inset 0 1px 0 rgba(255,255,255,0.05)' 
              : '0 20px 40px rgba(15, 23, 42, 0.08)',
            border: theme === 'dark' ? '1px solid rgba(255,255,255,0.06)' : '1px solid rgba(15, 23, 42, 0.04)',
            transition: 'all 0.3s ease',
          }}
        >
          <Outlet />
        </div>
      </div>
    </div>
  );
}
